import { cn } from "@/lib/utils"

interface AgentCardProps {
  name: string
  role: string
  description: string
  color: "teal" | "sage" | "amber" | "coral" | "slate"
}

// Desaturated, harmonious palette aligned with SOTA colorimetry principles
// Uses analogous colors with reduced saturation to minimize visual fatigue
const colorClasses = {
  teal: "border-teal-600/25 bg-teal-600/5 hover:bg-teal-600/8",
  sage: "border-emerald-700/25 bg-emerald-700/5 hover:bg-emerald-700/8",
  amber: "border-amber-600/25 bg-amber-600/5 hover:bg-amber-600/8",
  coral: "border-rose-600/25 bg-rose-600/5 hover:bg-rose-600/8",
  slate: "border-slate-500/25 bg-slate-500/5 hover:bg-slate-500/8",
}

const dotColors = {
  teal: "bg-teal-500",
  sage: "bg-emerald-600",
  amber: "bg-amber-500",
  coral: "bg-rose-500",
  slate: "bg-slate-400",
}

export function AgentCard({ name, role, description, color }: AgentCardProps) {
  return (
    <div
      className={cn(
        "p-5 rounded-lg border transition-all duration-200 hover:shadow-md",
        colorClasses[color]
      )}
    >
      <div className="flex items-center gap-3 mb-3">
        <div className={cn("w-2 h-2 rounded-full", dotColors[color])} />
        <div>
          <h4 className="font-semibold text-foreground">{name}</h4>
          <p className="text-xs text-muted-foreground">{role}</p>
        </div>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {description}
      </p>
    </div>
  )
}
